export default {
      id: "industry-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#industry",
      toString: function () {
        return this.url;
      }
    }